module.exports = __webpack_public_path__ + "kudos_13.svg?b067985c7baceb7e94ac54afe31735fc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_13.svg
// module id = 110
// module chunks = 0